<template>
  <div class="content">
    <div class="tips" v-show="isWeixin">
      请复制页面地址,在手机浏览器中打开
    </div>
    <div class="box" v-show="isWeixin">
      <div class="url">{{message}}</div>
      <div class="btn" @click="copy">复制</div>
    </div>
    <div style="text-align:center;margin-top:90px">
      <img style="width:200px;height:200px" class="img" src="@/assets/dongtai.gif" alt="">
      <div >页面跳转中<div class="loading">...</div></div>
    </div>
    <a style="display:none" ref="anzhuo"  class="download" :href="anzhuoSrc">
    </a>
    <a style="display:none" ref="isIos"  class="download" :href="iosSrc" @click="ios($event)">
    </a>
    <div class="btn-down" v-show="!isWeixin" @click="isIosOrAndroid">下载APP</div>
    <div v-show="show" ref="backdrop" class="bd_drop" @click="bdrop">
      <span class="tip" />
      <p class="tip_text">点击右上角选择<br>在浏览器中打开</p>
    </div>
  </div>
</template>

<script>
import service  from '../utils/request'
export default {
  data() {
    return {
      iosOrAndroid: false,
      show: false,
      message:'https://livelab.com.cn/website/#/downloadApp',
      iosSrc:'https://apps.apple.com/cn/app/%E7%8E%B0%E5%9C%BA%E5%AE%9E%E9%AA%8C%E5%AE%A4/id1566835977',
      isWeixin:false,
      anzhuoSrc:''
    };
  },
  mounted(){

  },
  methods: {
    copy(){
      //如果不需要回调：
        this.$copyText(this.message)
        //如果需要回调：
        this.$copyText(this.message).then( e => {
          this.$message('复制成功')
        }, function (e) {
          this.$message.error('复制失败')
        })
    },
    // 判断ios Or  安卓
   async isIosOrAndroid() {
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; // android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
      // alert('是否是Android：' + isAndroid);
      // alert('是否是iOS：' + isiOS);
      console.log("是否是Android：" + isAndroid);
      console.log("是否是iOS：" + isiOS);
      const res= await service({
      url: '/appSettings/appVersion/app/check',
      method: 'get',
      params:{
        appOsType:'2',
        appVersion:'1.1.0'
      },
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
    this.anzhuoSrc=res.data.versionInfo.appApkUrl
      if (isiOS) {
        this.iosOrAndroid = false;
        this.$nextTick(()=>{
          this.$refs.isIos.click()
        })
        window.location.href=this.iosSrc
      } else {
        this.$nextTick(()=>{
          this.$refs.anzhuo.click()
        })
        this.weixinTip();
        this.iosOrAndroid = true;
      }
    },
    // 判断是否微信打开
    weixinTip() {
      var ua = navigator.userAgent;
      var isWeixin = !!/MicroMessenger/i.test(ua);
      this.isWeixin=isWeixin
      isWeixin ? (this.show = true) : (this.show = false);
    },
    // 安卓下载
    anzhuo(e) {
      if (this.show === true) {
        window.event ? (window.event.returnValue = false) : e.preventDefault();
        this.show === true
          ? (this.$refs.backdrop.style.display = "block")
          : (this.$refs.backdrop.style.display = "none");
      }
    },
    // ios下载
    ios() {
      window.event ? (window.event.returnValue = false) : e.preventDefault();
      this.$refs.backdrop.style.display = "none";
    },
    // 点击遮罩层关闭
    bdrop() {
      this.$refs.backdrop.style.display = "none";
    },
  },
  created() {
    this.isIosOrAndroid();
  },

};
</script>
<style lang = 'scss' scoped>

.btn-down{
    color: #fff;
    /* height: 50px; */
    height: 250px;
    width: 70%;
    line-height: 250px;
    border-radius: 125px;
    background: red;
    text-align: center;
    margin: 0 auto;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 300px;
}
.content{
  overflow: hidden;
  width: 100vw;
  height: 100vh;
  .title{
    font-size: 100px;
    line-height: 180px;
    font-weight: bold;
  }
  .tips{
    margin-top: 20px;
  }
  .box{
    display: flex;
    width: 100vw;
    .url{
      width: 1700px;
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap;
    }
    .btn{
      color: red;
    }
  }
}
.download {
  position: absolute;
  display: block;
  top: 85%;
  height: 200px;
  line-height: 200px;
  width: 60%;
  text-align: center;
  background: red;
  left: 20%;
}
.bd_drop{
  background: rgba(0, 0, 0, 0.8);
  text-align: center;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 998;
  display: none;
}
.tip{
  width: 42.625vw;
  height: 32vw;
  position: absolute;
  color: #fff;
  right: 50px;
  top: 30px;
  background: url("../assets/WechatIMG85.png") no-repeat center center;
  background-size: 100% 100%;
}
.tip_text {
  font-style: italic;
  color: #fff;
  font-size: 26px;
  line-height: 2;
  position: absolute;
  width: 40%;
  height: 150px;
  padding-top: 26px;
  box-sizing: border-box;
  left: 30%;
  border: 2px #fff dashed;
  border-radius: 75px;
  top:40%;
  transform: translateY(-50%)
}
.loading{display: inline-block;text-align: center;margin: 0 auto;overflow: hidden;height: 1em;line-height: 1em;vertical-align: -.25em;}

.loading::before{
  display: block;
content: '...\A..\A.';
white-space: pre-wrap;
animation: dot 2s infinite step-start both;
}
@keyframes dot {
  33%{transform: translateY(-2em);}
66%{transform: translateY(-1em);}
  };
</style>
